import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { LeaveFormModalService } from '@components/unsaved-form-changes-guard/leave-form-modal.service';
import { Observable } from 'rxjs';

export interface DeactivationGuarded {
  isDirty: boolean;
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedFormChangesGuard  {
  constructor(private unsavedFormChangesGuardService: LeaveFormModalService) {}

  canDeactivate(
    component: DeactivationGuarded,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.isDirty) {
      return this.unsavedFormChangesGuardService.confirmModal();
    }
    return true;
  }
}
